import { ParsedError } from './ParsedError'

export class ImplementationError extends ParsedError {
  override readonly tag = 'implementation'

  override readonly attributes: Record<string, unknown>

  constructor(customAttributes: Record<string, unknown>) {
    super()
    this.attributes = customAttributes
  }
}
